<script setup>
import { RouterView } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useAppStore } from "@/stores/app";
import { useAriaDisabledSync } from "@/composables/useAriaDisabledSync";
import LoadingIcon from "@/components/common/LoadingIcon.vue";

// Bootstrap our app
const user = useUserStore();
useAppStore();

// Mirror native `disabled` attribute to `aria-disabled` on all form controls
// so assistive technologies announce disabled state consistently (CIR-2816).
useAriaDisabledSync();
</script>

<template lang="pug">
  template(v-if="user.initCompleted")
    .appMain(class="min-h-screen bg-gray-50 dark:bg-gray-900")
      RouterView

  div(v-else class="h-screen grid place-items-center")
    LoadingIcon(size="big")

</template>
